/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

export interface TopicsList {
  [key: string]: string | null | TopicsList;
}

const Topics: TopicsList = {
  datasources: {
    attachments: '.*',
    commengine: '.*',
    config: '.*',
    experiments: '.*',
    flow: '.*',
    hva: '.*',
    identity: '.*',
    linkednotebook: '.*',
    message: '.*',
    note: '.*',
    notebook: '.*',
    preference: '.*',
    profile: '.*',
    promotion: '.*',
    quickswitcher: '.*',
    search: '.*',
    sharednotekeys: '.*',
    survey: '.*',
    tag: '.*',
    task: '.*',
    threads: '.*',
    user: '.*',
    workspace: '.*'
  },
  attachments: {
    actions: '.*'
  },
  client: '.*',
  notifications: {
    status: null
  },
  system: {
    network: null,
    components: {
      sugar: null,
      view: null,
      search: null
    }
  },
  app: {
    actions: '.*',
    bootstrap: '.*',
    businessmode: '.*',
    fullysynced: '.*',
    history: '.*',
    i18n: '.*',
    loading: '.*',
    progress: '.*',
    service: '.*',
    validuser: '.*',
    synced: '.*'
  },
  config: {
    actions: '.*'
  },
  message: '.*',
  note: {
    actions: '.*',
    datasource: '.*',
    utils: '.*',
    error: '.*'
  },
  notebook: {
    actions: '.*'
  },
  flow: {
    actions: '.*',
    utils: '.*'
  },
  hva: {
    actions: '.*'
  },
  linkednotebook: {
    actions: '.*'
  },
  preference: {
    actions: '.*'
  },
  search: '.*',
  sharednotekeys: '.*',
  survey: {
    actions: '.*'
  },
  workspace: {
    actions: '.*',
    utils: '.*'
  },
  tag: {
    actions: '.*'
  },
  task: {
    actions: '.*',
    datasource: '.*'
  },
  tests: '.*',
  user: {
    actions: '.*',
    events: '.*',
    access: '.*'
  },
  autoupdater: {
    events: '.*'
  },
  login: {
    events: '.*'
  },
  threads: {
    actions: '.*'
  },
  service: {
    note: '.*',
    notebook: '.*',
    linkednotebook: '.*',
    search: '.*',
    tag: '.*',
    user: '.*',
    sharednotekeys: '.*',
    threads: '.*'
  },
  sync: {
    initialsyncdone: '*',
    actions: '.*',
    notes: '.*',
    persist: '.*'
  },
  submitfeedback: {
    actions: '.*'
  },
  sugar: 'init',
  promotion: {
    actions: '.*',
    utils: '.*'
  },
  crosspromotion: {
    actions: '.*'
  },
  business: {
    sso: '.*',
    getshard: '.*'
  },
  personal: {
    getshard: '.*'
  },
  identity: {
    actions: '.*'
  },
  profile: {
    actions: '.*'
  },
  logrequest: {
    actions: '.*'
  },
  experiments: {
    actions: '.*'
  },
  commengine: {
    actions: '.*'
  },
  quickswitcher: {
    actions: '.*'
  },
  workchat: {
    actions: '.*'
  },
  shortcuts: {
    actions: '.*'
  },
  dropdown: '.*',
  cupboard: {
    get: null,
    set: null,
    clear: null,
    clearnamespace: null,
    migrate: null
  },
  rtsclient: {
    actions: '.*'
  },
  boron: '.*',
  ui: {
    notes: '.*',
    window: '.*'
  },
  editor: {
    message: '.*'
  },
  copilot: {
    switch: '.*'
  }
};

export default Topics;
